module.exports = __webpack_public_path__ + "static/media/transitional_anchorage.a13f0aac.svg";